<template>
  <v-dialog v-model="show" max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline" v-if="isEdited">{{
          $t("students.edit_client")
        }}</span>
        <span class="headline" v-else>{{ $t("students.add_client") }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="student.name"
                  :label="$t('students.name')"
                  autofocus
                  :rules="rules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field 
                  v-model="student.last_name"
                  :label="$t('students.last_name')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="student.identifier"
                  :label="$t('students.identifier')"
                  :rules="rules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="student.email"
                  item-text="email"
                  item-value="email"
                  :label="$t('students.email')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5">
                <v-switch
                  color="green"
                  v-model="student.is_active"
                  :label="
                    student.is_active
                      ? $t('general.active')
                      : $t('general.not_active')
                  "
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="submit">{{
          $t("general.save")
        }}</v-btn>
        <v-btn @click.stop="show = false">{{ $t("general.cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StudentForm",
  props: {
    form: {
      type: Object,
    },
    student: Object,
    visible: Boolean,
    isEdited: Boolean,
    variables: Object
  },

  data() {
    return {
      companies: [],
      divisions: [],
      sections: [],
      checkedDefault: true,
      valid: true,
      showEye: false,
      rules: [(value) => !!value || this.$t("general.required")],
    };
  },

  watch: {
    show(val) {
      !val && this.$refs.form.reset();
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  created() {
    this.getCompanies();
    this.getDivisions();
    this.getSections();
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.isEdited) {
          await axios
            .put(`/updateStudent/${this.student.id}`, this.student, {
              headers: {
                Authorization:
                  "Bearer " + this.$store.state.tokenData.user.access_token,
              },
            })
            .then((response) => {
              if (response.data.isError) {
                this.$emit("snackMessage", response.data.message, "warning");
              } else {
                // response.data.roleName = response.data.role == "admin" ? "Admin": "Uživatel";
                this.$emit("updateStudent", response.data);
                this.$emit("snackMessage", "student.client_saved", "success");
                this.$emit("close");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$emit("snackMessage", "general.error", "error");
            });
        } else {
          await axios
            .post(`/storeStudent`, this.student, {
              headers: {
                Authorization:
                  "Bearer " + this.$store.state.tokenData.user.access_token,
              },
            })
            .then((response) => {
              if (response.data.isError) {
                this.$emit("snackMessage", response.data.message, "warning");
              } else {
                this.$emit("addStudent", response.data);
                this.$emit("snackMessage", "students.client_added", "success");
                this.$emit("close");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$emit("snackMessage", "general.error", "error");
            });
        }
      }
    },
    async getCompanies() {
      await axios
        .get("/companyList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    async getDivisions() {
      await axios
        .get("/divisionList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.divisions = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    async getSections() {
      await axios
        .get("/sectionList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.sections = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
  },
};
</script>
